<template>
    <div class="sign-in">
        <div class="sign-in__wrapper">
            <div class="sign-in__bg">
                <div class="sign-in__form-wrapper">
                    <div class="sign-in__form">
                        <div class="sign-in__form-inside">
                            <div class="sign-in__form-inside-box">
                                <div class="sign-in__logo-wrapper">
                                    <img src="@assets/images/header/logo-nlb-buy&go.png" alt="NLB Buy&Go logo"
                                        class="sign-in__logo">
                                </div>

                                <div class="sign-in__form-content">
                                    <h1 class="sign-in__title">Vpis v partnersko aplikacijo</h1>
                                    <!-- Sign in form -->
                                    <v-form @keyup.enter="loginSummit()">

                                        <!-- Uporaniško ime -->
                                        <div>
                                            <!-- <img src="@assets/images/sign-in/icon-dashboard copy.svg" alt=""> -->
                                            <label class="form-label">Uporabniško ime</label>
                                            <v-text-field variant="outlined" v-model="login.username"
                                                :error-messages="v$.username.$errors[0] != null ? v$.username.$errors[0].$message : ''"
                                                @focus="v$.username.$reset">
                                            </v-text-field>
                                        </div>

                                        <!-- Password -->
                                        <div>
                                            <label class="form-label">Geslo</label>
                                            <v-text-field v-model="publicStore.login.password"
                                                :error-messages="v$.password.$errors[0] != null ? v$.password.$errors[0].$message : ''"
                                                @focus="v$.password.$reset" 
                                                variant="outlined"
                                                :append-inner-icon="showPassword ? 'custom:iconPasswordVisible' : 'custom:iconPasswordNotVisible'"
                                                :type="showPassword ? 'text' : 'password'"
                                                @click:append-inner="showPassword = !showPassword">
                                            </v-text-field>
                                        </div>

                                        <div v-if="login.loginError !== ''"
                                            class="notification notification--warning mt-4">
                                            {{ $t('LoginScreen.' + login.loginError) }}
                                        </div>

                                        <!-- Sign in btn -->
                                        <v-btn @click="loginSummit()" flat
                                            class="btn btn--primary-inverted-fill btn--animated mt-4">
                                            Prijava
                                            <span class="icon-wrapper">
                                                <v-icon class="icon icon-current">mdi-arrow-right</v-icon>
                                                <v-icon class="icon icon-next">mdi-arrow-right</v-icon>
                                            </span>
                                        </v-btn>

                                        <div class="divider divider--horizontal"></div>

                                        <!-- Forgot pass link -->
                                        <div class="panel-sign-in__password-reset">
                                            V primeru pozabljenega gesla nam pošljite e-mail s svojimi podatki na <a
                                                class="link link--inverted"
                                                href="mailto:prodaja@nlbbuygo.si?subject=Pozabljeno%20geslo%20|%20NLB%20Bu&Go%20Partnerska%20aplikacija">prodaja@nlbbuygo.si</a>
                                            ali nas pokličite na 01 320 05 51.
                                        </div>
                                    </v-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sign-in__image-curve-wrapper">
                    <div class="sign-in__image-curve"></div>
                </div>
                <div class="sign-in__image">
                    <img src="/images/image-login.jpg" alt="Login image" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { usePublicStore, ILoginForm } from "@publicstore/store";
    import { computed, ComputedRef, ref } from "vue";
    import { useVuelidate } from "@vuelidate/core";
    import errors from "@/app/global-errors";

    const publicStore = usePublicStore();
    const login: ComputedRef<ILoginForm> = computed(() => publicStore.login);

    async function loginSummit() {
        await validateForm().then(() => {
            v$.value.$reset();
        });
        publicStore.userLogin();
    };

    async function validateForm(): Promise<void> {
        v$.value.$touch();
        let formValid = await v$.value.$validate();
        return new Promise((resolve) => {
            if (formValid) {
                resolve();
            }
        });
    };

    const validationRules = computed(() => ({
        username: {
            required: errors.fieldRequired,
        },
        password: {
            required: errors.fieldRequired,
        }
    }));

    const v$: any = useVuelidate(validationRules, login, { $autoDirty: true });

    const showPassword = ref(false);
</script>
